module.exports = __webpack_public_path__ + "img/internet-router-icon.f531ceb4.svg";